import { render, staticRenderFns } from "./my_resolved.vue?vue&type=template&id=6d6627a6&scoped=true"
import script from "./my_resolved.vue?vue&type=script&lang=js"
export * from "./my_resolved.vue?vue&type=script&lang=js"
import style0 from "./my_resolved.vue?vue&type=style&index=0&id=6d6627a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6627a6",
  null
  
)

export default component.exports